"use client";

import { cn } from "../../utils";
import { Controls as ControlsPrimitive } from "@xyflow/react";
import type { ComponentProps } from "react";

export type ControlsProps = ComponentProps<typeof ControlsPrimitive>;

export const Controls = ({ className, ...props }: ControlsProps) => (
  <ControlsPrimitive
    className={cn(
      "al-gap-px al-overflow-hidden al-rounded-md al-border al-bg-card al-p-1 al-shadow-none!",
      "[&>button]:al-rounded-md [&>button]:al-border-none! [&>button]:al-bg-transparent! [&>button]:hover:al-bg-secondary!",
      className
    )}
    {...props}
  />
);
